export const SESSION_CONST = {
    DEVICE_INSTRUCTION: 'instruction',
    INIT_ERROR: 'Session is not initilized',
    ERROR_IN_JOINING_CONFERENCE: 'Could not connect to the session. Please refresh your browser',
    ROOM_INIT_ERROR: 'initilize_session_room_error',
    LOCAL_RECORDING_INIT_ERROR: 'local_recording_init_error',
    ID: 'id',
    GUEST_ID: 'guestId',
    SESSION_NOT_FOUND: 'session not found',
    JOIN_PERMISION: 'Please contact the host to join.',
    GUEST: 'guest',
    HOST: 'host',
    GUEST_EX_ID: 'GuestExId',
    LIVE_STREAM_ERROR: 'There is some issue with live streaming, retry or contact to administrator.',
    LIVE_STREAM_LINKDIN_ERROR: 'There is some issue with linkdin live streaming (maybe already streamed), retry or contact to administrator.',
    RECORDING_META_ERROR: 'recording meta data is not saved.',
    LOCAL_RECORDING_ERROR: 'There is some issue with local recording, retry or contact administrator.',
    CONFRENCE_INIT_ERROR: 'Conference is not initialized.',
    RTMP_STREAM_ERROR: 'Dolby issue with rtmps server.',
    PARTICIPANT_LIMIT: 6,
    PREVIEW: 'preview',
    LOCAL_RECORDING_IDB_ERROR: 'There is some issue while saving local recording, retry or contact administrator.',
    LOCAL_RECORDING_IDB_GET_FILE_ERROR: 'There is some issue while uploading local recording, retry or contact administrator.',
    LIVE_RECORDING_ERROR: 'There is some issue with web recording',
    SESSION_NOT_LIVE: 'Session is not live',
    LOCAL_RECORDING_EVENT_TO_GUEST: 'Local recording is not started at guest side',
    END_CALL_ERROR: 'There is an issue with end call.',
    CONFERENCE_STATE: 'CONFERENCE_STATE',
    CONSTRAINT_CONFIG_ERR: 'There is an issue with device configuration.',
    CAMERA_ERR: 'There is an issue with Camera',
    MIC_ERR: 'There is an issue with Mic',
    LOW_PROCESSOR: 'Video recording resolution {content} downgraded to 480p based on the computer processor detected',
    LOW_STORAGE: 'Disk space too low for {name} to record in studio quality. Please ask to connect from a different device. If you proceed, only web recording (combined tracks) is guaranteed.',
    CONTENT_REPLACE: '{content}',
    MIXER: 'Mixer',
    MINIMUL_BLOCK: 'minimul-block',
    MEDIA_DURATION_ERR: 'Duration cannot exceed 30 sec',
    MEDIA_FILE_SIZE_ERR: 'File size cannot exceed 15MB',
    ON_CONFERENCE_MEDIA_ID: 'on-conference-media',
    LINKEDIN_REGION:'WEST_US',
    REM_DEVICES: 'REM_DEVICES'
  }
  